// extracted by mini-css-extract-plugin
module.exports = {"container":"aghanims_container_3Avm_","on":"aghanims_on_2Xz_D","glow":"aghanims_glow_3Xhmi","off":"aghanims_off_3Zr-7","icon":"aghanims_icon_VSK3e","small":"aghanims_small_1SVJR"};